import React from "react";
import { Link } from "react-router-dom";
import beePhoto from "../assets/dandelion.jpg";

export default function Hero() {
  return (
    <section className="pt-16 pb-16 md:pb-24">
      <div className="mx-auto max-w-6xl items-center gap-10 md:grid-cols-[1.15fr_0.85fr]">
        <div className=" bg-gradient-to-br from-amber-100 via-white to-emerald-50">
          <div>
            <img
              className="w-full h-[50vh] object-cover object-center"
              src={beePhoto}
              alt="Dandelion Bee"
            />
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            <div className=" bg-forest p-6 text-white shadow-soft sm:col-span-2">
              {/* <div className="text-sm uppercase tracking-[0.25em] text-amber-200">
                    Cedar & Comb
                  </div>*/}
              <div className="text-3xl font-semibold leading-tight">
                Beekeeping services for Olympia and the South Sound
              </div>
              <div className="mt-3 text-sm leading-6 text-white/80">
                Purpose-built for a damp climate, steady forage windows, and
                beekeepers who want stock that fits the region.
              </div>
            </div>

            <div className=" bg-white p-5 shadow-soft">
              <div className="text-sm uppercase tracking-[0.18em] text-slate-500">
                Region focus
              </div>
              <div className="mt-2 text-xl font-semibold text-slate-900">
                Queens
              </div>
              <div className="mt-2 text-sm leading-6 text-slate-600">
                Queens bred and grown here, in the PNW. Available late
                spring/early summer as weather allows.
              </div>
              <Link
                to="/contact"
                className="mt-6 text-sm font-semibold text-amber-800"
              >
                Learn more →
              </Link>
            </div>

            <div className=" bg-white p-5 shadow-soft">
              <div className="text-sm uppercase tracking-[0.18em] text-slate-500">
                Overwintered
              </div>
              <div className="mt-2 text-xl font-semibold text-slate-900">
                Nucleus Colonies
              </div>
              <div className="mt-2 text-sm leading-6 text-slate-600">
                Overwintered nucs with our own queen. Available early Spring
                while supplies last.
              </div>
              <Link
                to="/contact"
                className="mt-6 text-sm font-semibold text-amber-800"
              >
                Learn more →
              </Link>
            </div>

            <div className=" bg-white p-5 shadow-soft">
              <div className="text-sm uppercase tracking-[0.18em] text-slate-500">
                Professional Management
              </div>
              <div className="mt-2 text-xl font-semibold text-slate-900">
                Hive Placement and Management
              </div>
              <div className="mt-2 text-sm leading-6 text-slate-600">
                Want a hive of bees in your garden, or 20 in your orchard? Get
                all of the benefits (and honey) out of your bees with none of
                the hassle.
              </div>
              <Link
                to="/contact"
                className="mt-6 text-sm font-semibold text-amber-800"
              >
                Learn more →
              </Link>
            </div>

            <div className=" bg-white p-5 shadow-soft">
              <div className="text-sm uppercase tracking-[0.18em] text-slate-500">
                Removal
              </div>
              <div className="mt-2 text-xl font-semibold text-slate-900">
                Swarm Management
              </div>
              <div className="mt-2 text-sm leading-6 text-slate-600">
                Do you have a swarm of bees or an unwanted nest in an old shed?
                Call us today for removal. We also handle wasps without
                Chemicals.
              </div>
              <Link
                to="/contact"
                className="mt-6 text-sm font-semibold text-amber-800"
              >
                Learn more →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
